/** Lightweight `clsx`-style class joiner used across the UI kit. */
export function cn(...args: unknown[]): string {
  return args.filter(Boolean).join(' ');
}

export type ToneSemantic = 'emerald' | 'gold' | 'rose' | 'ink';
